/* unplugin-vue-components disabled */import script from "./NewComerDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewComerDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewComerDialog.vue?vue&type=style&index=0&id=6ceeb5a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ceeb5a4"]])

export default __exports__